// extracted by mini-css-extract-plugin
module.exports = {"editor":"App_editor_1vuCM","left":"App_left_11On2","main":"App_main_2xcRE","right":"App_right_3MxHp"};